import { UsersTable } from "@/features/users/users-table";
import { CreateUserButton } from "@/features/users/create-user-button";

export function UsersScreen() {
  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">Users</h1>
        <CreateUserButton />
      </div>
      <UsersTable />
    </div>
  );
}
